<template>
    <section id="program" class="features-area">
        <div class="container">
            <div class="secondary-heading text-center">ESSENS TURKEY 2026</div>
            <h1 class="text-center mb-5"> {{ $t('turkey2024Hg') }} </h1>
            <div class="row d-flex justify-content-center">               
                    <div class="col-md-6 col-12">
                       <h2>Hotel Balmy Foresta</h2>
                       <br>
                       <p v-html="$t('turkey2026AcT1')"></p>
                    </div>
                    <div class="col-md-6 col-12">
                        <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" style="width: 100%;">
                            <source src="@/assets/hotel.mp4" type="video/mp4">
                        </video> 
                    </div>            
            </div>
            <div class="row d-flex justify-content-center" style="padding-top: 50px;">
               
               <div class="col-md-6 col-12">
                  <h2>{{ $t('turkey2024Pf') }}</h2>
                  <br>
                  <p v-html="$t('turkey2026P2')"></p>
               </div>
               <div class="col-md-6 col-12 order-lg-first">
                    <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" style="width: 100%;">
                        <source src="@/assets/letadlo.mp4" type="video/mp4">
                    </video> 
               </div>
         
       </div>
       <div class="row d-flex justify-content-center" style="padding-top: 50px;">
               
               <div class="col-md-6 col-12">
                  <h2>{{ $t('turkey2023P3') }}</h2>
                  <br>
                  <p v-html="$t('turkey2026P3')"></p>
               </div>
               <div class="col-md-6 col-12">
                    <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" style="width: 100%;">
                        <source src="@/assets/seluz.mp4" type="video/mp4">
                    </video> 
               </div>
         
       </div>
        </div>
    </section>
</template>

<script setup>
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n()

</script>

<style>
    #program {
        background-color: var(--grey-bg);
    }

    #program .col-md-6 {
    align-self: center;
    }

    .features-area p:first-of-type {
        margin-bottom: 0;
        text-align: justify;
        padding-bottom: 10px;
    }
</style>